<template>
  <div class="cashbook-container">
    <div class="header">
      <h2>Triple-Column Cash Book</h2>
      <div class="actions">
        <input type="date" v-model="fromDate" />
        <input type="date" v-model="toDate" />
        <button @click="fetchCashBook">Load</button>
        <button @click="printCashBook">Print</button>
      </div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Ref</th>
            <th>Cash (₦)</th>
            <th>Bank (₦)</th>
            <th>Discount (₦)</th>
            <th>Balance (₦)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entry, index) in cashBookEntries" :key="index">
            <td>{{ entry.date }}</td>
            <td>{{ entry.description }}</td>
            <td>{{ entry.ref }}</td>
            <td>{{ formatAmount(entry.cash) }}</td>
            <td>{{ formatAmount(entry.bank) }}</td>
            <td>{{ formatAmount(entry.discount) }}</td>
            <td>{{ formatAmount(entry.balance) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "TripleCashBook",
  data() {
    return {
      fromDate: this.today(),
      toDate: this.today(),
      cashBookEntries: [],
    };
  },
  methods: {
    today() {
      return new Date().toISOString().substr(0, 10);
    },
    async fetchCashBook() {
      // Replace this with your actual API request
      const res = {
        data: [
          {
            date: "2025-06-10",
            description: "Opening Balance",
            ref: "OB",
            cash: 50000,
            bank: 30000,
            discount: 0,
            balance: 80000,
          },
          {
            date: "2025-06-11",
            description: "Sales Revenue",
            ref: "SR001",
            cash: 20000,
            bank: 15000,
            discount: 1000,
            balance: 116000,
          },
          {
            date: "2025-06-11",
            description: "Utility Payment",
            ref: "UP002",
            cash: -5000,
            bank: -10000,
            discount: 0,
            balance: 101000,
          },
        ],
      };

      this.cashBookEntries = res.data;
    },
    printCashBook() {
      window.print();
    },
    formatAmount(value) {
      return value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    this.fetchCashBook();
  },
};
</script>

<style scoped>
.cashbook-container {
  margin-top: 1em;
  padding: 1rem;
  border: 1px solid black;
  background: #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.actions input {
  margin-right: 0.5rem;
  padding: 6px;
}

.actions button {
  margin-left: 0.5rem;
  padding: 6px 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.actions button:hover {
  background: #0056b3;
}

.table-wrapper {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

th,
td {
  padding: 0.75rem;
  border: 1px solid #ddd;
  text-align: left;
}

th {
  background: #f4f4f4;
}
</style>
